import Skeleton from '@/components/ui/Skeleton'
import { cn } from '@/lib/utils'
import {
  DICTIONARY_LIST,
  DICTIONARY_ROW,
} from '@/screens/courses/components/dictionary/dictionary-list-box'

/**
 * Five rows at the loaded list's own row box — a typical results page, not a
 * live measurement (the dictionary is empty on dev).
 */
const ROWS = ['w-24', 'w-32', 'w-20', 'w-28', 'w-24'] as const

export default function DictionaryListSkeleton() {
  return (
    <div aria-hidden="true" className={DICTIONARY_LIST}>
      {ROWS.map((width, index) => (
        <div key={index} className={cn(DICTIONARY_ROW, 'flex flex-col gap-1 px-5 py-3')}>
          <Skeleton className={`h-4 rounded-xs ${width}`} />
          <Skeleton className="h-3 w-2/3 rounded-xs" />
        </div>
      ))}
    </div>
  )
}
